import { render, staticRenderFns } from "./compared.vue?vue&type=template&id=c5a45194&scoped=true&"
import script from "./compared.vue?vue&type=script&lang=js&"
export * from "./compared.vue?vue&type=script&lang=js&"
import style0 from "./compared.vue?vue&type=style&index=0&id=c5a45194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a45194",
  null
  
)

export default component.exports